import React, {useRef, useState, useEffect, useCallback} from "react";
import SignatureCanvas from "react-signature-canvas";
import "./SignatureComponent.css";
import {Bounce, toast} from "react-toastify";

const SignatureComponent = (
    {
        finishEvaluation, companySignatureImage, setCompanySignatureImage,
        technicianSignatureImage, setTechnicianSignatureImage
    }:
    {
        finishEvaluation: () => void;
        companySignatureImage: string | null;
        setCompanySignatureImage: (value: string | null) => void;
        technicianSignatureImage: string | null;
        setTechnicianSignatureImage: (value: string | null) => void;
    }) => {
    const companySignatureRef = useRef<SignatureCanvas | null>(null);
    const technicianSignatureRef = useRef<SignatureCanvas | null>(null);
    const [step, setStep] = useState(1);
    const [canvasWidth, setCanvasWidth] = useState(400);

    const updateCanvasSize = useCallback(() => {
        const parentWidth = document.getElementById("signature-container")?.offsetWidth || 400;
        setCanvasWidth(parentWidth * 0.9);
    }, []);

    useEffect(() => {
        updateCanvasSize();
        window.addEventListener("resize", updateCanvasSize);
        return () => window.removeEventListener("resize", updateCanvasSize);
    }, [updateCanvasSize]);


    const handleNext = () => {
        const canvas = companySignatureRef.current;
        if (canvas && canvas.isEmpty()) {
            toast.warning('Por favor firme para continuar',
                {
                    position: 'top-right',
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: false,
                    theme: 'colored',
                    transition: Bounce,
                }
            );
            return;
        }

        const companyImage = canvas?.toDataURL("image/png");
        setCompanySignatureImage(companyImage || null);
        canvas?.clear();
        setStep(2);
    };

    const handleFinish = () => {
        if (step === 2) {
            const canvas = technicianSignatureRef.current;
            if (canvas && canvas.isEmpty()) {
                toast.warning('Por favor firme para continuar',
                    {
                        position: 'top-right',
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false,
                        theme: 'colored',
                        transition: Bounce,
                    }
                );
                return;
            }

            const technicianImage = canvas?.toDataURL("image/png");
            setTechnicianSignatureImage(technicianImage || null);
            canvas?.clear();
        }
        // Set loading animation
    };

    const handleClear = (ref: React.RefObject<SignatureCanvas>) => {
        ref.current?.clear();
    };

    useEffect(() => {
        if (companySignatureImage && technicianSignatureImage) {
            finishEvaluation()
        }
    }, [companySignatureImage, technicianSignatureImage]);

    return (
        <div id="signature-container" className="signature-container">
            <h2 className="signature-title">
                {step === 1 ? "Firma de la empresa" : "Firma del técnico"}
            </h2>
            {step === 1 ? (
                <SignatureCanvas
                    ref={companySignatureRef}
                    canvasProps={{
                        width: canvasWidth,
                        height: 200,
                        className: "signature-canvas",
                    }}
                />
            ) : (
                <SignatureCanvas
                    ref={technicianSignatureRef}
                    canvasProps={{
                        width: canvasWidth,
                        height: 200,
                        className: "signature-canvas",
                    }}
                />
            )}
            <div className="button-container-signature">
                {step === 1 ? (
                    <div className="buttons-container-signature-bottom">
                        <button onClick={handleNext} className="button-next">Siguiente</button>
                        <button onClick={() => handleClear(companySignatureRef)} className="button-next">Borrar</button>
                    </div>
                ) : (
                    <div className="buttons-container-signature-bottom">
                        <button onClick={handleFinish} className="button-finish">Terminar</button>
                        <button onClick={() => handleClear(technicianSignatureRef)} className="button-next">Borrar</button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default SignatureComponent;
